import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface ISelectItem {
  label: string;
  selected: boolean;
  select?: () => void; // Optional, otherwise bind to onSelect Output from parent;
}

/**  Custom YourAPP SelectElement
 * takes an Array of Items implementing ISelectItem
 * and provides an onSelect which returns the selected item
 * to avoid boilerplate binding.
 * <ya-select (onSelect)="console.log($event)">
 * alternatively provide select Method in ISelectItem.
*/
@Component({
  selector: 'ya-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [],
})
export class SelectComponent<T extends ISelectItem> {

  @Input() items: T[] = [];

  @Output() onSelect = new EventEmitter<T>();

  constructor() {

  }

  selectItem(item: T) {
    if (item.select) {
      item.select();
    }
    this.onSelect.emit(item);
  }

}
